export var SHOW = 'open';
export var HIDE = 'close';
export var DIALOG = 'Dialog';